export enum searchEntityType {
  clinic = 'clinic',
  clinicOwner = 'clinicOwner',
  professional = 'professional',
  specialization = 'specialization',
  appointmentType = 'appointmentType',
}
